import EndPointConfig from '../../models/api/endPointConfig';

const controller = 'EmailsConfiguration';

export const EmailsEP: EndPointConfig[] = [
    new EndPointConfig()
        .setMethod('GET')
        .setController(controller)
        .setActionName('frequency')
        .setAlias('GetEmailFrequencyConfiguration'),
    new EndPointConfig()
        .setMethod('PATCH')
        .setController(controller)
        .setActionName('frequency')
        .setAlias('UpdateEmailFrequencyConfiguration'),

    new EndPointConfig()
        .setMethod('GET')
        .setController(controller)
        .setActionName('notifications')
        .setAlias('GetEmailsNotification'),

    new EndPointConfig()
        .setMethod('DELETE')
        .setController(controller)
        .setPattern('notifications/{id}')
        .setAlias('DeleteEmailsNotification'),

    new EndPointConfig()
        .setMethod('POST')
        .setController(controller)
        .setPattern('notifications/')
        .setAlias('CreateEmailsNotification'),
    new EndPointConfig()
        .setMethod('PATCH')
        .setController(controller)
        .setPattern('notifications/{id}')
        .setAlias('UpdateSelectionDefault'),
    new EndPointConfig()
        .setMethod('PATCH')
        .setController(controller)
        .setActionName('notifications')
        .setAlias('UpdateNotifications'),
];
